<template>
    <div id="recording_retention_panel">
        <template v-if="$store.hasRight('VIEW_RETENTION_RULES')">
            <RetentionPeriods id="periods_panel" @change="setPeriods" />
            <RetentionRules id="rules_panel" :periods="periods" />
        </template>
        <Panel v-if="$store.hasRight('EDIT_ORG_DEFAULT_RECORDING_RETENTION')" :title="$t('Default Purging Settings')">
            <div class="item-form">
                <ul>
                    <li class="form-label-first">{{ $t('Purge recordings') }}</li>
                    <li><cic-checkbox id="recordings_purge" :value="purge" @input="(val) => (purge = val)" /></li>
                    <template v-if="purge">
                        <li class="form-label">{{ $t('Duration to store recordings (days)') }}</li>
                        <li>
                            <cic-textbox
                                id="recordings_keep_days"
                                :value="keepRecordingsDays"
                                :int-only="true"
                                :maxlength="4"
                                @input="(val) => (keepRecordingsDays = val)"
                            />
                        </li>
                    </template>
                </ul>
            </div>
            <template #footer>
                <cic-button id="config_save_button" @click="saveConfig">
                    {{ $t('Save default purging settings') }}
                </cic-button>
            </template>
        </Panel>
    </div>
</template>

<script>
    import CicButton from '@/components/CicButton';
    import Panel from '@/components/container/Panel';
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import CicTextbox from '@/components/inputs/CicTextbox';
    import { load, save } from '@/utils/Http';
    import RetentionPeriods from './RetentionPeriods';
    import RetentionRules from './RetentionRules';
    import './styles/recordingRetention.scss';

    export default {
        name: 'RecordingRetention',
        components: {
            CicButton,
            CicCheckbox,
            CicTextbox,
            Panel,
            RetentionPeriods,
            RetentionRules,
        },
        data() {
            return {
                keepRecordingsDays: null,
                periods: [],
                purge: null,
            };
        },
        created() {
            if (this.$store.hasRight('EDIT_ORG_DEFAULT_RECORDING_RETENTION')) {
                this.loadTable();
            }
        },
        methods: {
            loadTable() {
                load('retention/get', {}, (response) => {
                    this.purge = response.purge;
                    this.keepRecordingsDays = response.keepRecordingsDays;
                });
            },

            setPeriods(periods) {
                this.periods = periods;
            },

            saveConfig() {
                save('retention/update', {
                    purge: this.purge ? 1 : 0,
                    keepRecordingsDays: this.keepRecordingsDays,
                });
            },
        },
    };
</script>
